<template>
  <div class="page">
  </div>
</template>

<script>

  export default {
    components: {},
    data () {
      return {
        payWay: '',
        codeBig: '',
        path: '',
        ceShiText: ''
//        window.location.href = `${domain}/payPage?payWay=${payWay}&code=${code}&path=${encodeURIComponent(path)}`
      }
    },
    created () {

    },
    methods: {
      payment (codeBig) {
        if (!codeBig) {
          this.utils.toastNone('缺失参数！')
          return
        }
        let base = window.location.origin
        if (this.payWay == 'sys_pay_wx') {
          this.http.getRequest({
            url: `pay/execute/${codeBig}`,
            msg: {},
            success: (res) => {
              if (res.data) {
                let wxUrl = res.data
                let redirect_url = encodeURIComponent((`${window.origin}/payPage?configId=${this.$route.query.configId}`))
                window.location.href = `${wxUrl}&redirect_url=${redirect_url}`
              }
            }
          })
        } else if (this.payWay == 'sys_pay_wx_account') {
          if (!this.utils.isWeixin()) {
            this.utils.toastNone('请在微信浏览器中打开！')
            return
          }
          this.wxPay(codeBig)
        } else {
          window.location.href = `${base}/api/pay/execute/${codeBig}`
        }
      },
      goTo (i) {
        let path = window.localStorage.getItem('pathUrl')
        if (i == 'sys_pay_wx') {
          window.location.href = `${path}/payResult?payWay=${i}&configId=${this.$route.query.configId}`
        } else if (i == 'sys_pay_wx_account') {
          window.location.href = `${path}/payResult?payWay=${i}`
        } else {
          window.location.href = `${path}/payResult?payWay=${i}`
        }
      },
      //微信支付
      wxPay (codeBig) {
        this.http.getRequest({
          url: `pay/execute/${codeBig}`,
          msg: {},
          success: (res) => {
            if (res.data) {
              var vm = this
              if (typeof WeixinJSBridge === 'undefined') {
                if (document.addEventListener) {
                  setTimeout(()=>{
                    document.addEventListener('WeixinJSBridgeReady', vm.onBridgeReady(res.data), false)
                  },1000)
                } else if (document.attachEvent) {
                  setTimeout(()=>{
                    document.attachEvent('WeixinJSBridgeReady', vm.onBridgeReady(res.data))
                    document.attachEvent('onWeixinJSBridgeReady', vm.onBridgeReady(res.data))
                  },1000)
                }
              } else {
                this.onBridgeReady(res.data)
              }
            }
          }
        },true)
      },
      onBridgeReady (data) {
        let obj = JSON.parse(data)
        let _that = this
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', {
            'appId': obj.appId,     //公众号ID，由商户传入
            'timeStamp': obj.timeStamp,         //时间戳，自1970年以来的秒数
            'nonceStr': obj.nonceStr, //随机串
            'package': obj.package,
            'signType': obj.signType,         //微信签名方式：
            'paySign': obj.paySign //微信签名
          },
          function (res) {
            let payWay = window.localStorage.getItem('payWay')
            _that.goTo(payWay)
          })
      }
    },
    mounted () {
      if (this.$route.query.payWay && this.$route.query.codeBig && this.$route.query.path && this.$route.query.configId) {
        this.payWay = this.$route.query.payWay
        this.codeBig = this.$route.query.codeBig
        this.path = decodeURIComponent(this.$route.query.path)
        window.localStorage.setItem('pathUrl', this.path ? this.path : '')
        window.localStorage.setItem('payWay', this.payWay ? this.payWay : '')
         this.payment(this.codeBig)
      } else {
        let payWay = window.localStorage.getItem('payWay')
        this.goTo(payWay)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/less" lang="less" scoped>

</style>

